<div class="rb-dialog">

  <!-- Header -->
  <div class="rb-header">
    <div class="rb-title-row">
      <span class="rb-op-badge" [ngClass]="{
        'op-create': operation?.toLowerCase() === 'create',
        'op-update': operation?.toLowerCase() === 'update',
        'op-delete': operation?.toLowerCase() === 'delete'
      }">{{operation}}</span>
      <span class="rb-title">{{entityName}}</span>
    </div>
    <button type="button" class="rb-close-btn" (click)="cancel()" title="Close">
      <i class="fas fa-times"></i>
    </button>
  </div>

  <!-- Metadata grid -->
  <div class="rb-meta-grid">
    <div class="rb-meta-item">
      <span class="rb-meta-label"><i class="fas fa-hashtag"></i> Queue / ID</span>
      <span class="rb-meta-value">{{entityId}}</span>
    </div>
    <div class="rb-meta-item">
      <span class="rb-meta-label"><i class="fas fa-tag"></i> Config Name</span>
      <span class="rb-meta-value">{{entityName}}</span>
    </div>
    <div class="rb-meta-item">
      <span class="rb-meta-label"><i class="fas fa-user"></i> Changed By</span>
      <span class="rb-meta-value">{{changedBy}}</span>
    </div>
    <div class="rb-meta-item">
      <span class="rb-meta-label"><i class="fas fa-clock"></i> Timestamp</span>
      <span class="rb-meta-value">{{timestamp}}</span>
    </div>
    <div class="rb-meta-item">
      <span class="rb-meta-label"><i class="fas fa-globe"></i> Environment</span>
      <span class="rb-meta-value">{{environment}}</span>
    </div>
    <div class="rb-meta-item">
      <span class="rb-meta-label"><i class="fas fa-cogs"></i> Service</span>
      <span class="rb-meta-value">{{serviceName}}</span>
    </div>
  </div>

  <!-- Before / After state -->
  <div class="rb-state-panels">
    <div class="rb-state-panel rb-before">
      <div class="rb-panel-header">
        <i class="fas fa-history"></i>
        <span>Before State</span>
        <span class="rb-panel-badge before-badge">Old Values</span>
      </div>
      <pre class="rb-state-json">{{beforeStateJson}}</pre>
    </div>
    <div class="rb-state-panel rb-after">
      <div class="rb-panel-header">
        <i class="fas fa-check-circle"></i>
        <span>After State</span>
        <span class="rb-panel-badge after-badge">New Values</span>
      </div>
      <pre class="rb-state-json">{{afterStateJson}}</pre>
    </div>
  </div>


</div>
